var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "content-hub bg-white p-3 p-md-4" }, [
    _c(
      "div",
      { staticClass: "content-hub--tags d-flex p-0" },
      [_c("ci-breadcrumbs", { attrs: { items: _vm.breadCrumbs } })],
      1
    ),
    _c("h1", {
      staticClass: "h1 m-0 mt-2",
      domProps: { textContent: _vm._s(_vm.contentHub.title) },
    }),
    _c(
      "div",
      {
        staticClass:
          "row flex-shrink-0 align-items-center justify-content-start m-0 mt-4",
      },
      [
        _c("div", { staticClass: "ci-article-tile__reading_time mr-4" }, [
          _c("div", { staticClass: "mdi mdi-timer-outline mr-1" }),
          _c("span", {
            domProps: {
              textContent: _vm._s(
                _vm.$tc(
                  "ui.shared.global.minutes.abbr",
                  _vm.contentHub.reading_minutes
                )
              ),
            },
          }),
        ]),
        _c("div", { staticClass: "ci-article-tile__meta mr-4" }, [
          _c("div", { staticClass: "mdi mdi-calendar-blank mr-1" }),
          _c("time", {
            directives: [
              {
                name: "ci-format-date",
                rawName: "v-ci-format-date",
                value: {
                  value: _vm.contentHub.publication_date,
                  opts: { year: "2-digit", month: "2-digit", day: "2-digit" },
                },
                expression:
                  "{ value: contentHub.publication_date, opts: { year: '2-digit', month: '2-digit', day: '2-digit' } }",
              },
            ],
          }),
        ]),
        _c("ci-share", {
          attrs: {
            "tracking-target": _vm.shareTrackingTarget,
            url: _vm.sharingUrl,
            title: _vm.contentHub.title,
            description: _vm.contentHub.teaser,
            dropdown: true,
            "prevent-toggle": false,
            type: "content_hub",
            networks: _vm.sharingNetworks,
            label: _vm.$t("social_share"),
          },
        }),
      ],
      1
    ),
    _vm.copyright.author
      ? _c(
          "div",
          { staticClass: "row m-0 mt-2 p-4" },
          [
            _c("ci-user-tile", {
              attrs: {
                user: _vm.copyright.author,
                "with-send-message": true,
                "with-profile-link": false,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "row m-0" },
      [
        _c("CompileHtml", {
          staticClass: "content-hub--text",
          attrs: { html: _vm.contentHub.text },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }